import { HTMLAttributes } from 'react';

import { twMerge } from 'tailwind-merge';
import { cardStyles, Typography } from '../../../ui';
import { IconMapMarker, IconPen, IconTrashAlt } from '@maia/icons';
import { Button } from 'react-aria-components';

type Props = {
  address: string;
  onDelete?: () => void;
  onEdit?: () => void;
} & HTMLAttributes<HTMLDivElement>;

export function FoundAddressCard(props: Props) {
  const { address, onDelete, onEdit, className, ...rest } = props;

  return (
    <div
      className={twMerge(
        cardStyles({ variant: 'info' }),
        'py-20 px-16',
        className,
      )}
      {...rest}
    >
      <div className="flex flex-row gap-x-12">
        <IconMapMarker className="min-w-24 w-24 h-24 fill-primaryMain" />

        <div className="flex flex-row items-center w-full">
          <Typography
            variant="body-s"
            weight="medium"
            className="text-grayscale500 flex-1"
          >
            {address}
          </Typography>

          {(onEdit || onDelete) && (
            <div className="flex items-center gap-12">
              {onDelete && (
                <Button onPress={onDelete}>
                  <IconTrashAlt className="min-w-20 w-20 h-20 fill-primaryMain" />
                </Button>
              )}

              {onEdit && (
                <Button onPress={onEdit}>
                  <IconPen className="min-w-20 w-20 h-20 fill-primaryMain" />
                </Button>
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
